import React, { useState } from 'react'
import Tab from 'components/common/Tab';
import { constant } from 'constants/constant';
import moment from 'moment';
import { CommonDateRange, CustomSelect, Heading } from 'components';
import { FaPlay, FaStop } from 'react-icons/fa6';
import './fleetoverview.css'

const FleetOverview = () => {

    const [activeTab, setActiveTab] = useState(2);

    const [selectedRange, setSelectedRange] = useState({
        startDate: moment().startOf('month'),
        endDate: moment().endOf('month'),
    });

    const callBackTab = (data) => {
        setActiveTab(data);
    }

    const tabProps = {
        tabList: constant.gpsDetailsTabs,
        callBackTab: callBackTab,
        activeTab: activeTab
    }

    const arryOptions = [
        { label: "Arjun", value: "01" },
        { label: "Anvit", value: "02" },
    ];

    return (
        <>
            <Heading title={"Fleet Overview"} />

            <div className='__fleetOvw_main '>
                <div className="__mainGps_bx">
                    <div className='_frFilts_gpsMain'>
                        <div className='_frFilts_gps'>
                            <div className='__frmMrx'>
                                <div className='__frFiltInnr'>
                                    <p>Estimated</p>
                                    <h4>450 KM</h4>
                                </div>

                                <div className='__frFiltInnr'>
                                    <p>GPS Running</p>
                                    <h4>472 KM</h4>
                                </div>

                                <div className='__frFiltInnr'>
                                    <p>Odometer Running</p>
                                    <h4>483 KM</h4>
                                </div>
                            </div>

                            <div className='__frmMrx'>
                                <div className='__frFiltInnr'>
                                    <p>GPS Fuel</p>
                                    <h4>10 Ltr</h4>
                                </div>

                                <div className='__frFiltInnr'>
                                    <p>Fuel Out</p>
                                    <h4>10.5 Ltr</h4>
                                </div>

                                <div className='__frFiltInnr'>
                                    <p>Difference</p>
                                    <h4 style={{ color: '#e51f1f' }}>0.5 Ltr</h4>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='_secFilts_gps'>
                        <Tab {...tabProps} />

                        <div className='__flOver_filtsOt'>
                            <div>
                                <CommonDateRange
                                    key={`${selectedRange.startDate}-${selectedRange.endDate}`}
                                    initialStartDate={selectedRange.startDate}
                                    initialEndDate={selectedRange.endDate}
                                    onApply={{}}
                                />
                            </div>

                            <div>
                                <CustomSelect
                                    label="Vehicle Number"
                                    placeholder="Vehicle Number"
                                    options={arryOptions}
                                />
                            </div>
                        </div>
                    </div>

                    {activeTab === 1 && (
                        <div className='__fltTier_tableBx'>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Vehicle</th>
                                        <th>Start Time</th>
                                        <th>End Time</th>
                                        <th>Start Location</th>
                                        <th>End Location</th>
                                        <th>Distance</th>
                                        <th>Duration</th>
                                        <th>Mileage</th>
                                        <th>Fuel</th>
                                        <th>Running Status</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td><div className='__fltHist_txs'>MP20GA2109</div></td>

                                        <td>
                                            <div className='__fltHist_txs'>12:00 AM</div>
                                            <div className='__fltHist_txs'>25-2-25</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>1:00 AM</div>
                                            <div className='__fltHist_txs'>26-2-25</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>Tadipatri - Bangalore Road</div>
                                            <div className='__fltHist_txs'>Paragodu</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>Tadipatri - Bangalore Road</div>
                                            <div className='__fltHist_txs'>Paragodu</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>50 KM</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>4:30 H</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>5</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>10 Ltr</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>Empty</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><div className='__fltHist_txs'>MP20GA2109</div></td>

                                        <td>
                                            <div className='__fltHist_txs'>12:00 AM</div>
                                            <div className='__fltHist_txs'>25-2-25</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>1:00 AM</div>
                                            <div className='__fltHist_txs'>26-2-25</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>Tadipatri - Bangalore Road</div>
                                            <div className='__fltHist_txs'>Paragodu</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>Tadipatri - Bangalore Road</div>
                                            <div className='__fltHist_txs'>Paragodu</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>50 KM</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>4:30 H</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>5</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>10 Ltr</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>Empty</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><div className='__fltHist_txs'>MP20GA2109</div></td>

                                        <td>
                                            <div className='__fltHist_txs'>12:00 AM</div>
                                            <div className='__fltHist_txs'>25-2-25</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>1:00 AM</div>
                                            <div className='__fltHist_txs'>26-2-25</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>Tadipatri - Bangalore Road</div>
                                            <div className='__fltHist_txs'>Paragodu</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>Tadipatri - Bangalore Road</div>
                                            <div className='__fltHist_txs'>Paragodu</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>50 KM</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>4:30 H</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>5</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>10 Ltr</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>Empty</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><div className='__fltHist_txs'>MP20GA2109</div></td>

                                        <td>
                                            <div className='__fltHist_txs'>12:00 AM</div>
                                            <div className='__fltHist_txs'>25-2-25</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>1:00 AM</div>
                                            <div className='__fltHist_txs'>26-2-25</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>Tadipatri - Bangalore Road</div>
                                            <div className='__fltHist_txs'>Paragodu</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>Tadipatri - Bangalore Road</div>
                                            <div className='__fltHist_txs'>Paragodu</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>50 KM</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>4:30 H</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>5</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>10 Ltr</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>Empty</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}

                    {activeTab === 2 && (
                        <div className='__fltTierBx'>
                            <div className='__flxTierDx'>
                                <div className='__gpsTimeLine_bx'>

                                    <div className='__fltsFlects_main'>
                                        <div className='__fltsFlects_time'>
                                            <div>
                                                <h4>12:00 AM</h4>
                                                <p>12/2/2025</p>
                                            </div>

                                            <div>
                                                <h4>12:00 AM</h4>
                                                <p>12/2/2025</p>
                                            </div>
                                        </div>
                                        <div className='__fltsFlects_detail __fltsFlects_stop'>
                                            <span className='__verLine_flt'></span>

                                            <div className='__fltsDetail_inr'>
                                                <h4>Stop</h4>
                                                <h5>1m | Ideal 0Min</h5>
                                                <p>Tadipatri - Bangalore Road, Paragodu,</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='__fltsFlects_main'>
                                        <div className='__fltsFlects_time'>
                                            <div>
                                                <h4>12:00 AM</h4>
                                                <p>12/2/2025</p>
                                            </div>

                                            <div>
                                                <h4>12:00 AM</h4>
                                                <p>12/2/2025</p>
                                            </div>
                                        </div>
                                        <div className='__fltsFlects_detail __fltsFlects_running'>
                                            <span className='__verLine_flt'></span>

                                            <div className='__fltsDetail_inr'>
                                                <h4>Running</h4>
                                                <h5>42m | 52.5 KM | Ideal 1min | Avg 32KM/H</h5>
                                                <p>Tadipatri - Bangalore Road, Paragodu,</p>
                                                <p>Tadipatri - Bangalore Road, Paragodu,</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='__fltsFlects_main'>
                                        <div className='__fltsFlects_time'>
                                            <div>
                                                <h4>12:00 AM</h4>
                                                <p>12/2/2025</p>
                                            </div>

                                            <div>
                                                <h4>12:00 AM</h4>
                                                <p>12/2/2025</p>
                                            </div>
                                        </div>
                                        <div className='__fltsFlects_detail __fltsFlects_stop'>
                                            <span className='__verLine_flt'></span>

                                            <div className='__fltsDetail_inr'>
                                                <h4>Stop</h4>
                                                <h5>1m | Ideal 0Min</h5>
                                                <p>Tadipatri - Bangalore Road, Paragodu,</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='__fltsFlects_main'>
                                        <div className='__fltsFlects_time'>
                                            <div>
                                                <h4>12:00 AM</h4>
                                                <p>12/2/2025</p>
                                            </div>

                                            <div>
                                                <h4>12:00 AM</h4>
                                                <p>12/2/2025</p>
                                            </div>
                                        </div>
                                        <div className='__fltsFlects_detail __fltsFlects_running'>
                                            <span className='__verLine_flt'></span>

                                            <div className='__fltsDetail_inr'>
                                                <h4>Running</h4>
                                                <h5>42m | 52.5 KM | Ideal 1min | Avg 32KM/H</h5>
                                                <p>Tadipatri - Bangalore Road, Paragodu,</p>
                                                <p>Tadipatri - Bangalore Road, Paragodu,</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='__fltsFlects_main'>
                                        <div className='__fltsFlects_time'>
                                            <div>
                                                <h4>12:00 AM</h4>
                                                <p>12/2/2025</p>
                                            </div>

                                            <div>
                                                <h4>12:00 AM</h4>
                                                <p>12/2/2025</p>
                                            </div>
                                        </div>
                                        <div className='__fltsFlects_detail __fltsFlects_stop'>
                                            <span className='__verLine_flt'></span>

                                            <div className='__fltsDetail_inr'>
                                                <h4>Stop</h4>
                                                <h5>1m | Ideal 0Min</h5>
                                                <p>Tadipatri - Bangalore Road, Paragodu,</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='__fltsFlects_main'>
                                        <div className='__fltsFlects_time'>
                                            <div>
                                                <h4>12:00 AM</h4>
                                                <p>12/2/2025</p>
                                            </div>

                                            <div>
                                                <h4>12:00 AM</h4>
                                                <p>12/2/2025</p>
                                            </div>
                                        </div>
                                        <div className='__fltsFlects_detail __fltsFlects_running'>
                                            <span className='__verLine_flt'></span>

                                            <div className='__fltsDetail_inr'>
                                                <h4>Running</h4>
                                                <h5>42m | 52.5 KM | Ideal 1min | Avg 32KM/H</h5>
                                                <p>Tadipatri - Bangalore Road, Paragodu,</p>
                                                <p>Tadipatri - Bangalore Road, Paragodu,</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div className='__gpsMapbx' >
                                    <iframe style={{ width: "100%", height: "calc(100% - 84px)", minHeight: "422px" }} frameborder={0} scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=720&amp;height=600&amp;hl=en&amp;q=Charted%20Bus%20Stand+(Transport360)&amp;t=&amp;z=17&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.gps.ie/">gps tracker sport</a></iframe>
                                    
                                    <div className='__dummyPlayer'>
                                        <div className='__dummyPlayer_date'>
                                            <h4>2:24 AM, <span>25/02/2025</span></h4>
                                        </div>

                                        <div className='__dummyPlayer_pl_stop'>
                                            <button><FaPlay /></button>
                                            <button><FaStop /></button>
                                        </div>

                                        <div className='__dummyPlayer_speed'>
                                            <p>Play Speed</p>
                                            <button className='active'>10X</button>
                                            <button>20X</button>
                                            <button>50X</button>
                                            <button>100X</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === 3 && (
                        <div className='__fltTier_tableBx'>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Vehicle</th>
                                        <th>Start Time</th>
                                        <th>End Time</th>
                                        <th>Start Location</th>
                                        <th>End Location</th>
                                        <th>Distance</th>
                                        <th>Duration</th>
                                        <th>Mileage</th>
                                        <th>Fuel</th>
                                        <th>Running Status</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td><div className='__fltHist_txs'>MP20GA2109</div></td>

                                        <td>
                                            <div className='__fltHist_txs'>12:00 AM</div>
                                            <div className='__fltHist_txs'>25-2-25</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>1:00 AM</div>
                                            <div className='__fltHist_txs'>26-2-25</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>Tadipatri - Bangalore Road</div>
                                            <div className='__fltHist_txs'>Paragodu</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>Tadipatri - Bangalore Road</div>
                                            <div className='__fltHist_txs'>Paragodu</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>50 KM</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>4:30 H</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>5</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>10 Ltr</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>Empty</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><div className='__fltHist_txs'>MP20GA2109</div></td>

                                        <td>
                                            <div className='__fltHist_txs'>12:00 AM</div>
                                            <div className='__fltHist_txs'>25-2-25</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>1:00 AM</div>
                                            <div className='__fltHist_txs'>26-2-25</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>Tadipatri - Bangalore Road</div>
                                            <div className='__fltHist_txs'>Paragodu</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>Tadipatri - Bangalore Road</div>
                                            <div className='__fltHist_txs'>Paragodu</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>50 KM</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>4:30 H</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>5</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>10 Ltr</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>Empty</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><div className='__fltHist_txs'>MP20GA2109</div></td>

                                        <td>
                                            <div className='__fltHist_txs'>12:00 AM</div>
                                            <div className='__fltHist_txs'>25-2-25</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>1:00 AM</div>
                                            <div className='__fltHist_txs'>26-2-25</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>Tadipatri - Bangalore Road</div>
                                            <div className='__fltHist_txs'>Paragodu</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>Tadipatri - Bangalore Road</div>
                                            <div className='__fltHist_txs'>Paragodu</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>50 KM</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>4:30 H</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>5</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>10 Ltr</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>Empty</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><div className='__fltHist_txs'>MP20GA2109</div></td>

                                        <td>
                                            <div className='__fltHist_txs'>12:00 AM</div>
                                            <div className='__fltHist_txs'>25-2-25</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>1:00 AM</div>
                                            <div className='__fltHist_txs'>26-2-25</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>Tadipatri - Bangalore Road</div>
                                            <div className='__fltHist_txs'>Paragodu</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>Tadipatri - Bangalore Road</div>
                                            <div className='__fltHist_txs'>Paragodu</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>50 KM</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>4:30 H</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>5</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>10 Ltr</div>
                                        </td>

                                        <td>
                                            <div className='__fltHist_txs'>Empty</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default FleetOverview